import React, { useEffect } from "react";
import GenericRoutes from "./Routes";
import { AuthProvider } from "./lib/context/Auth/AuthContext";
import { NavbarProvider } from "./lib/context/NavBar/navbarContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { manageAppVersion } from "./lib/utils/versionManager";
import { useVersionCheck } from "./lib/hooks/useVersionCheck";
function App() {
  const APP_VERSION = "1.2.11";



  useEffect(() => {
    manageAppVersion(APP_VERSION, {
      cookiesToPreserve: [
        "user_preferences",
        "auth_token",
        "session",
        "refresh_token",
        "userToken"
      ],
      localStorageToClear: [
        "old_cache",
        "deprecated_data",
      ],
      shouldReload: true
    });
  }, [APP_VERSION]);

  const { isUpdateAvailable, reloadToUpdate } = useVersionCheck(APP_VERSION);

  useEffect(() => {
    if (isUpdateAvailable) {
      toast.info(
        // <div>
        //   New version available! <br />
        //   <button
        //     onClick={reloadToUpdate}
        //     style={{
        //       marginTop: '8px',
        //       padding: '6px 12px',
        //       backgroundColor: '#fff',
        //       color: '#333',
        //       border: 'none',
        //       borderRadius: '4px',
        //       cursor: 'pointer'
        //     }}
        //   >
        //     Update Now
        //   </button>
        // </div>,
        {
          position: "bottom-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          toastId: "app-update-top-right",
        }
      );
    }
  }, [isUpdateAvailable, reloadToUpdate]);


  return (
    <AuthProvider>
      <NavbarProvider>
        <GenericRoutes />
        <ToastContainer />
      </NavbarProvider>
    </AuthProvider>
  );
}

export default App;